export enum ENavigationFormError {
  familyOrderFile = 'SFE0806',
  productIds = 'SFE0815',
}

export enum ENavigationStatus {
  PUBLISHED = 1,
  PENDING_PUBLICATION,
  INCOMPLETE_EDITION,
  EMPTY,
  DEFAULT,
}
